/* VEYR Scroll Intro - onboarding-overlay.
   EEN VEEG = EEN KAART. Tijdens de veeg scrubt de film mee onder je vinger; bij
   loslaten landt hij altijd precies op de volgende tekstkaart. Daardoor gaat in
   datzelfde gebaar de huidige tekst van het scherm en komt de volgende erin - nooit
   meerdere vegen waarin bijna niets verandert. Een filmscene zonder eigen tekst is
   geen halte: daar loopt het gebaar doorheen (zie STOPS), zodat de film niet stilvalt
   op een leeg beeld. De intro is niet over te slaan: de enige uitgang is de knop op
   de eindkaart, en die telt pas mee als die kaart ook echt in beeld staat. */
(function(){
  function init(root){
    if (root.dataset.oiInit) return;
    root.dataset.oiInit = '1';

    var once = root.dataset.once === 'true';
    var STORE_KEY = 'veyr_intro_seen_v2';
    try { if (once && sessionStorage.getItem(STORE_KEY)) { root.remove(); return; } } catch(e){}
    if (window.Shopify && window.Shopify.designMode) { root.remove(); return; }

    /* Het thema zet transform/filter op <main>; daardoor zou position:fixed aan main
       ankeren in plaats van aan de viewport. Op <body> klopt alles. */
    if (root.parentElement !== document.body) document.body.appendChild(root);

    var cfg = JSON.parse(root.querySelector('[data-oi="config"]').textContent);
    var T = cfg.T, N = T.length - 1;

    var BEAT_SWIPE = Math.max(100, parseFloat(root.dataset.beatswipe) || 300);
    var OPEN_SWIPE = Math.max(100, parseFloat(root.dataset.openswipe) || 480);
    /* Hoe snel de film na het loslaten mag doorlopen, in filmseconden per seconde. */
    var SCENE_SPEED = Math.max(0.8, parseFloat(root.dataset.scenespeed) || 2.4);
    /* Hoeveel vinger een gebaar kost. Een sprong over een lege scene loopt door, maar
       mag daardoor niet dubbel zo snel scrubben: hij kost iets meer vinger, niet evenredig. */
    function dragFull(from, to){
      var base = from === 0 ? OPEN_SWIPE : BEAT_SWIPE;
      var span = Math.abs(to - from);
      return base * (span <= 1 ? 1 : 1 + 0.55 * (span - 1));
    }

    var q = function(s){ return root.querySelector('[data-oi="' + s + '"]'); };
    var sheet = q('sheet'), video = q('video'), plate = q('plate');
    var cue = q('cue'), finalHint = q('final'), enterBtn = q('enter');
    var bar = q('bar'), edge = q('edge');
    var logolayer = q('logolayer'), logomask = q('logomask'), logomark = q('logomark');

    var beats = Array.prototype.slice.call(root.querySelectorAll('.veyr-oi__beat')).map(function(el){
      return { el: el, k: +el.dataset.k,
        inD: {x:+el.dataset.inx, y:+el.dataset.iny},
        outD: {x:+el.dataset.outx, y:+el.dataset.outy}, e: 1, v: 0 };
    });
    /* Landingspunten. Een scene zonder eigen tekst is geen halte: daar loopt de veeg
       gewoon doorheen, zodat de film niet stilvalt op een leeg beeld. De lijst komt dus
       uit de beats die er werkelijk staan, plus het begin en het eind. */
    var STOPS = [0, N];
    beats.forEach(function(b){ if (STOPS.indexOf(b.k) < 0) STOPS.push(b.k); });
    STOPS.sort(function(a,b){ return a - b; });
    function stopAt(i){ return STOPS[i < 0 ? 0 : (i > STOPS.length - 1 ? STOPS.length - 1 : i)]; }

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var DUR = T[N];
    var PLATEAU = 0.26, FLIGHT = 0.62;
    var OM_IN = 15.5, ZE_IN = 0.68, OM_OUT = 12.0, ZE_OUT = 0.42;

    root.hidden = false;
    document.documentElement.classList.add('veyr-oi-lock');

    fetch(root.dataset.video)
      .then(function(r){ if(!r.ok) throw 0; return r.blob(); })
      .then(function(b){ video.src = URL.createObjectURL(b); video.load(); })
      .catch(function(){ video.src = root.dataset.video; video.load(); });

    video.addEventListener('loadedmetadata', function(){
      DUR = Math.min(video.duration - 0.05, T[N]);
      video.pause(); video.currentTime = 0;
    });

    function vh(){ return window.innerHeight; }
    function placeLogo(){
      var cw = window.innerWidth, ch = vh();
      var scale = Math.max(cw / cfg.VIDEO_W, ch / cfg.VIDEO_H);
      var dw = cfg.VIDEO_W * scale, dh = cfg.VIDEO_H * scale;
      var px = (cw - dw)/2 + cfg.LOGO_U * dw;
      var py = (ch - dh)/2 + cfg.LOGO_V * dh;
      var markW = dw * 0.36;
      logomask.style.left = px+'px'; logomask.style.top = py+'px';
      /* De plaat moet het film-embleem dekken (tot ~160x125 videopixels vanaf het
         midden) en tegelijk zacht op nul kunnen uitlopen. Bij 0.50 x 0.26 zit dat
         embleem op ~65% van de ellips, dus blijft 35% over voor de uitloop. */
      logomask.style.width = (dw*0.50)+'px'; logomask.style.height = (dh*0.26)+'px';
      logomark.style.left = px+'px'; logomark.style.top = py+'px';
      logomark.style.width = markW+'px'; logomark.style.height = (markW*772/793)+'px';
    }
    window.addEventListener('resize', placeLogo);
    placeLogo();

    function clamp01(x){ return x<0?0:x>1?1:x; }
    function smoothstep(u){ u=clamp01(u); return u*u*(3-2*u); }
    function smootherstep(u){ u=clamp01(u); return u*u*u*(u*(u*6-15)+10); }

    function mapTime(x){
      var k = Math.min(N-1, Math.floor(x));
      var f = x-k;
      if (k===0){ f = clamp01((f-0.04)/0.96); }   /* openingskader houdt heel even stil */
      return Math.min(DUR, T[k] + (T[k+1]-T[k])*f);
    }

    /* ---- scene-navigatie ---- */
    var stopIdx = 0;        /* index in STOPS waar we op gelanden zijn */
    var posTarget = 0;      /* waar we heen willen, in scene-eenheden */
    var pos = 0;            /* wat er nu getoond wordt, volgt posTarget vloeiend */
    var dragging = false, dragPx = 0;

    function beginGesture(){ dragPx = 0; dragging = true; }
    function moveGesture(dy){
      if (dismissing) return;
      dragPx += dy;
      var dir = dragPx >= 0 ? 1 : -1;
      var from = stopAt(stopIdx), to = stopAt(stopIdx + dir);
      var f = Math.abs(dragPx) / dragFull(from, to);
      if (f > 1) f = 1;
      posTarget = from + (to - from) * f;
    }
    function endGesture(vel){
      if (dismissing) return;
      var dir = dragPx >= 0 ? 1 : -1;
      var from = stopAt(stopIdx), to = stopAt(stopIdx + dir);
      var f = Math.abs(dragPx) / dragFull(from, to);
      if (f > 0.22 || (f > 0.05 && vel * dir > 450)) stopIdx += dir;
      if (stopIdx < 0) stopIdx = 0;
      if (stopIdx > STOPS.length - 1) stopIdx = STOPS.length - 1;
      posTarget = stopAt(stopIdx);
      dragging = false;
      dragPx = 0;
    }
    function step(dir){
      if (dismissing) return;
      stopIdx = Math.max(0, Math.min(STOPS.length - 1, stopIdx + dir));
      posTarget = stopAt(stopIdx);
    }

    /* wiel: een burst telt als een gebaar, met dezelfde landingsregel */
    var wheelActive = false, wheelTimer = 0, wheelVel = 0, lastWheelT = 0;
    function onWheel(e){
      e.preventDefault();
      var now = performance.now();
      if (!wheelActive){ wheelActive = true; beginGesture(); }
      var d = e.deltaY * (e.deltaMode === 1 ? 18 : 1);
      var dt = Math.max(8, now - lastWheelT); lastWheelT = now;
      wheelVel = d / dt * 1000;
      moveGesture(d);
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function(){ wheelActive = false; endGesture(wheelVel); }, 130);
    }

    var touchY = 0, lastTouchT = 0, lastDY = 0;
    function onTouchStart(e){ touchY = e.touches[0].clientY; lastTouchT = performance.now(); lastDY = 0; beginGesture(); }
    function onTouchMove(e){
      e.preventDefault();
      var y = e.touches[0].clientY, dy = touchY - y;
      touchY = y;
      var now = performance.now(), dt = Math.max(8, now - lastTouchT);
      lastTouchT = now; lastDY = dy / dt * 1000;
      moveGesture(dy);
    }
    function onTouchEnd(){ endGesture(lastDY); }
    function onKey(e){
      if (e.key === 'ArrowDown' || e.key === ' ' || e.key === 'PageDown'){ e.preventDefault(); step(1); }
      else if (e.key === 'ArrowUp' || e.key === 'PageUp'){ e.preventDefault(); step(-1); }
      /* Escape sluit bewust niet: de intro moet uitgespeeld worden. Met de pijltjes of
         de spatiebalk kom je wel bij de eindkaart, dus er blijft een toetsenbordroute. */
    }
    root.addEventListener('wheel', onWheel, {passive:false});
    root.addEventListener('touchstart', onTouchStart, {passive:true});
    root.addEventListener('touchmove', onTouchMove, {passive:false});
    root.addEventListener('touchend', onTouchEnd, {passive:true});
    root.addEventListener('touchcancel', onTouchEnd, {passive:true});
    window.addEventListener('keydown', onKey);
    /* De knop op de eindkaart is de enige uitgang, en hij werkt pas als die kaart in
       beeld staat. Zonder die voorwaarde was de intro met de tabtoets over te slaan,
       want de knop staat vanaf het begin in de DOM. */
    var enterOpen = false;
    if (enterBtn){
      enterBtn.tabIndex = -1;
      enterBtn.addEventListener('click', function(){ if (enterOpen) dismiss(); });
    }

    var dismissing = false;
    function dismiss(){
      if (dismissing) return;
      dismissing = true;
      try { if (once) sessionStorage.setItem(STORE_KEY, '1'); } catch(e){}
      sheet.style.transition = 'transform .72s cubic-bezier(.7,0,.2,1), opacity .72s ease';
      sheet.style.transform = 'translate3d(0,-100%,0) scale(.96)';
      sheet.style.opacity = '0';
      root.style.pointerEvents = 'none';
      window.setTimeout(function(){
        document.documentElement.classList.remove('veyr-oi-lock');
        window.scrollTo(0, 0);
        root.remove();
      }, 720);
    }

    var vel = 0, lastT = performance.now();
    function frame(now){
      if (dismissing) return;
      var dt = Math.min(0.033,(now-lastT)/1000) || 0.016;
      lastT = now;

      /* onder de vinger strak volgen, bij loslaten zacht landen */
      var k = dragging ? 13.0 : 3.6;
      var prev = pos;
      var stap = (posTarget - pos) * (1 - Math.exp(-dt * k));
      if (!dragging){
        /* Snelheidsplafond in filmseconden per seconde. Zonder plafond doet een landing
           er even lang over ongeacht hoe ver ze reikt, dus schoot een sprong over twee
           scenes met dubbele snelheid voorbij - daar viel niets meer van te zien. Nu
           bepaalt de lengte van de scene onder pos hoeveel scene-eenheden er per
           seconde bij mogen, zodat elke landing even goed te volgen is. */
        var sc = Math.max(0, Math.min(N-1, Math.floor(pos)));
        var scLen = T[sc+1] - T[sc];
        var maxStap = (scLen > 0 ? SCENE_SPEED / scLen : 1) * dt;
        if (stap > maxStap) stap = maxStap;
        else if (stap < -maxStap) stap = -maxStap;
      }
      pos += stap;
      vel += (((pos - prev)/dt) - vel) * (1 - Math.exp(-dt * 5));

      var x = pos;
      var progress = N > 0 ? pos / N : 0;

      if (!reduced && video.readyState >= 2){
        var t = mapTime(x);
        if (Math.abs(t - video.currentTime) > 0.01) video.currentTime = t;
        var breath = Math.sin(now/1000*0.53*6.2832)*3;
        var ty = Math.max(-10, Math.min(10, -vel*26)) + breath;
        var rz = Math.max(-0.65, Math.min(0.65, vel*7));
        plate.style.transform = 'translate3d(0,'+ty.toFixed(2)+'px,0) scale(1.045) rotate('+rz.toFixed(3)+'deg)';
      }

      for (var i=0;i<beats.length;i++){
        var it = beats[i];
        var s = x - it.k, d = Math.abs(s);
        var entry = s < 0;
        var dir = entry ? it.inD : it.outD;
        var tE = d <= PLATEAU ? 0 : smootherstep((d-PLATEAU)/(FLIGHT-PLATEAU));
        if (reduced){ it.e = tE; it.v = 0; }
        else {
          var om = entry?OM_IN:OM_OUT, ze = entry?ZE_IN:ZE_OUT;
          it.v += (-om*om*(it.e-tE) - 2*ze*om*it.v)*dt;
          it.e += it.v*dt;
        }
        var e = it.e;
        var tx = dir.x*e*(window.innerWidth*0.5 + it.el.offsetWidth/2 + 24);
        var tyb = dir.y*e*(vh()*0.5 + it.el.offsetHeight/2 + 24);
        it.el.style.transform = 'translate3d('+tx.toFixed(1)+'px,'+tyb.toFixed(1)+'px,0)';
        it.el.style.opacity = (1 - smoothstep((Math.abs(e)-0.65)/0.35)).toFixed(3);
        if (!reduced){
          it.el.style.filter = 'blur('+(Math.min(1,Math.abs(e))*8).toFixed(2)+'px)';
          it.el.style.setProperty('--oi-ls',(Math.min(Math.abs(e)/0.4,1)*0.05).toFixed(4)+'em');
        }
      }

      logolayer.style.opacity = smoothstep((x-3.55)/0.75).toFixed(3);
      if (enterBtn){
        var open = x > N - 0.55;
        if (open !== enterOpen){ enterOpen = open; enterBtn.tabIndex = open ? 0 : -1; }
      }

      /* De aanwijzing blijft staan tot de eindkaart in beeld komt en dimt terwijl de
         vinger beweegt, zodat ze de film niet beconcurreert. Ze verdween eerder al na
         een vijfde van de intro, waardoor er halverwege niets meer om een veeg vroeg. */
      var cueOp = (1 - smoothstep((x - (N - 0.9)) / 0.8)) * (dragging ? 0.34 : 1);
      cue.style.opacity = cueOp.toFixed(3);
      if (edge) edge.style.opacity = cueOp.toFixed(3);

      if (finalHint) finalHint.style.opacity = '0';
      if (bar) bar.style.width = (progress*100).toFixed(2) + '%';

      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function boot(){
    var nodes = document.querySelectorAll('.veyr-oi');
    for (var i=0;i<nodes.length;i++) init(nodes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();